import { render } from "./ClientRegister.vue?vue&type=template&id=d45e506e&scoped=true"
import script from "./ClientRegister.vue?vue&type=script&lang=js"
export * from "./ClientRegister.vue?vue&type=script&lang=js"

import "./ClientRegister.vue?vue&type=style&index=0&id=d45e506e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45e506e"]])

export default __exports__